export default __webpack_public_path__ + "static/media/chris-farrel.be452487.webp";